var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "2%", height: "95%" },
          attrs: {
            title: _vm.title,
            width: 800,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _vm.isReadOnly
                ? _c(
                    "a-button",
                    { key: "back", on: { click: _vm.handleCancel } },
                    [_vm._v("\n        取消\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form, id: "userModal" } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "登录名称",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["loginName", _vm.validatorRules.loginName],
                            expression:
                              "[ 'loginName', validatorRules.loginName]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: {
                          placeholder: "请输入登录名称",
                          readOnly: !!_vm.model.id,
                        },
                      }),
                    ],
                    1
                  ),
                  !_vm.model.id
                    ? _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "用户密码",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input-password", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: [
                                  "password",
                                  _vm.validatorRules.password,
                                ],
                                expression:
                                  "[ 'password', validatorRules.password]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { placeholder: "请输入用户密码" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "用户姓名",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["username", _vm.validatorRules.username],
                            expression:
                              "[ 'username', validatorRules.username]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入用户姓名" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "角色",
                      },
                    },
                    [
                      !_vm.model.id || _vm.model.id !== _vm.model.tenantId
                        ? _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["roleId", _vm.validatorRules.roleId],
                                  expression:
                                    "[ 'roleId', validatorRules.roleId]",
                                },
                              ],
                              attrs: {
                                placeholder: "选择角色",
                                dropdownMatchSelectWidth: false,
                              },
                            },
                            _vm._l(_vm.roleList, function (item, index) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: item.id } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.name) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm.model.id === _vm.model.tenantId
                        ? _c(
                            "a-col",
                            [_c("a-row", [_vm._v(_vm._s(_vm.tenantRoleName))])],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "部门",
                      },
                    },
                    [
                      _c("a-tree-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["orgaId"],
                            expression: "[ 'orgaId' ]",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: {
                          dropdownStyle: {
                            maxHeight: "200px",
                            overflow: "auto",
                          },
                          "allow-clear": "",
                          treeData: _vm.orgaTree,
                          placeholder: "请选择部门",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.storeOptionsReady
                    ? _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "所属门店",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder: "未更改则不修改",
                                allowClear: "",
                              },
                              model: {
                                value: _vm.bindStoreId,
                                callback: function ($$v) {
                                  _vm.bindStoreId = $$v
                                },
                                expression: "bindStoreId",
                              },
                            },
                            [
                              _c("a-select-option", { attrs: { value: "" } }, [
                                _vm._v("无"),
                              ]),
                              _vm._l(_vm.storeOptionList, function (s) {
                                return _c(
                                  "a-select-option",
                                  { key: s.id, attrs: { value: s.id } },
                                  [_vm._v(_vm._s(s.name))]
                                )
                              }),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#999",
                                "font-size": "12px",
                                "margin-top": "2px",
                              },
                            },
                            [
                              _vm._v(
                                '选择门店后保存时将绑定该用户到门店（收银员场景）；选择"无"则清除门店绑定'
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "职位",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["position"],
                            expression: "[ 'position' ]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入职位" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "是否经理",
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["leaderFlag"],
                              expression: "[ 'leaderFlag' ]",
                            },
                          ],
                          attrs: { placeholder: "请选择是否经理" },
                        },
                        [
                          _c("a-select-option", { attrs: { value: "1" } }, [
                            _vm._v("是"),
                          ]),
                          _c("a-select-option", { attrs: { value: "0" } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "电话号码",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["phonenum"],
                            expression: "[ 'phonenum' ]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入电话号码" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "电子邮箱",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["email"],
                            expression: "[ 'email' ]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入电子邮箱" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "排序",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["userBlngOrgaDsplSeq"],
                            expression: "[ 'userBlngOrgaDsplSeq' ]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入排序" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "备注",
                      },
                    },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["description"],
                            expression: "[ 'description' ]",
                          },
                        ],
                        attrs: { rows: 2, placeholder: "请输入备注" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }